import env from '@shared/env.js'
import * as apiRequest from '@shared/api-endpoints'
import Tracker from '@shared/Tracker'
import useSelfTestStore from '@shared/modules/assessment/stores/useSelfTestStore.js'

// MSK EU submits the copy the patient saw to POST /v2/user/self_test; every
// other variant keeps sending bare values to POST /v2/user/complete_self_test.
// Callers own the error handling.
/**
 * @param {'full'|'preSignup'|'postSignup'} scope
 * @param {{ partial?: boolean }} [options]
 * @returns {Promise<unknown>}
 */
export const submitSelfTestAnswers = (scope, { partial = false } = {}) => {
  const store = useSelfTestStore()
  return env.isMskEu
    ? apiRequest.createSelfTest({ ...store.submission(scope), partial })
    : apiRequest.submitSelfTest({ answers: store.bareAnswers(scope), partial })
}

// The completing submission of a self test, from its last screen: sends the
// scope, then the lifecycle event with the bare values. A failure is swallowed;
// the onboarding goes on either way.
/**
 * @param {'full'|'postSignup'} scope
 * @returns {Promise<void>}
 */
export const completeSelfTest = async (scope) => {
  const store = useSelfTestStore()
  try {
    await submitSelfTestAnswers(scope)

    // Patient-written text belongs in the clinical submission only.
    const { goal_freetext: _goalFreetext, ...trackedAnswers } =
      store.bareAnswers(scope)
    Tracker.trackKaiaEvent(
      {
        event_name: 'c.lfcycl.submit_initial_assessment',
        action: 'submit',
        object_type: 'initial_assessment',
        screen_name: 'onb_finish_congratulations',
      },
      trackedAnswers,
    )
  } catch {
    /* empty */
  }
}
